export const AUTH_TOKEN = "kimulti_auth_token";
export const AUTH_PROFILE = "kimulti_auth_profile";
export const AUTH_PERMISSIONS = "kimulti_auth_permissions";
